module.exports = __webpack_public_path__ + "img/ac-favicon.192ac973.svg";